import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useState } from 'react';
import { ImportedOutgo, ImportedOutgoDetail } from 'types';
import { Buffer } from 'buffer';
import ImportedOutgoDetailRow from './ImportedOutgoDetailRow';

type Props = {
  importedOutgo: ImportedOutgo;
  onClickCsvImport: (fileName: string, content: string) => void;
  onClickUpdateImportedOutgoDetail: (updated: ImportedOutgoDetail) => void;
  onClickDeleteImportedOutgoDetail: (updated: ImportedOutgoDetail) => void;
  onClickApply: () => void;
  onClickDelete: () => void;
};

const ImportedOutgoEditTable: React.FC<Props> = ({
  importedOutgo,
  onClickCsvImport,
  onClickUpdateImportedOutgoDetail,
  onClickDeleteImportedOutgoDetail,
  onClickApply,
  onClickDelete,
}) => {
  const [files, setFiles] = useState<FileList | null>(null);
  const onClick = () => {
    if (!files) return;

    const file = files[0];
    if (!file) return;

    const fileReader = new FileReader();
    fileReader.onload = () => {
      if (!fileReader.result) return;
      if (typeof fileReader.result === 'string') return;

      onClickCsvImport(
        file.name,
        Buffer.from(fileReader.result).toString('base64'),
      );
    };
    fileReader.readAsArrayBuffer(file);
  };

  if (importedOutgo.filepath === null) {
    return (
      <>
        <input
          type="file"
          accept="text/csv"
          onChange={(event) => {
            setFiles(event.target.files);
          }}
        />
        <Button
          type="submit"
          variant="contained"
          sx={{ maxWidth: '128px' }}
          onClick={onClick}
        >
          インポート
        </Button>
      </>
    );
  }

  return (
    <>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>名前</TableCell>
              <TableCell>種別</TableCell>
              <TableCell>金額</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {importedOutgo.details.map((detail) => (
              <ImportedOutgoDetailRow
                key={detail.id}
                detail={detail}
                onClickUpdateImportedOutgoDetail={
                  onClickUpdateImportedOutgoDetail
                }
                onClickDeleteImportedOutgoDetail={
                  onClickDeleteImportedOutgoDetail
                }
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid container spacing={1}>
        <Grid item>
          <Button variant="contained" onClick={onClickApply}>
            反映
          </Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="error" onClick={onClickDelete}>
            削除
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default ImportedOutgoEditTable;
